import { useContext } from "react";
import { CartContext } from "../context/CartContext";

export const useRecords = () => {
  const {
    recordState,
    getRecords,
    addRecord,
    addDeletedRecord,
    editRecord,
    addEditForm,
    deleteRecord,
    restoreRecord,
    getDeletedRecords,
  } = useContext(CartContext);

  const { records, deletedRecords, editForm } = recordState;

  return {
    records: records,
    deletedRecords: deletedRecords,
    editForm: editForm,
    getRecords,
    getDeletedRecords,
    addRecord,
    addDeletedRecord,
    editRecord,
    addEditForm,
    deleteRecord,
    restoreRecord,
  };
};
